import styled from "styled-components"
import { Table } from "@mui/material"
import React, { ReactNode } from "react"
import { StickyScrollbar } from "./StickyScrollbar"
import { theme } from "../../../../theme"

export type TWrapperStickyScrollbarProps = {
  children?: ReactNode
  className?: string
}

export const TWrapperStickyScrollbar = (props: TWrapperStickyScrollbarProps) => {
  const { className, children } = props

  return (
    <StickyScrollbar className={className}>
      <CustomTable>{children}</CustomTable>
    </StickyScrollbar>
  )
}

const CustomTable = styled(Table)`
  font-size: ${theme.fontSize.m};
  white-space: nowrap;
`
